// @generated by protoc-gen-es v1.2.0 with parameter "target=js+dts"
// @generated from file wavin/aqora/v2/peripheral_mutation.proto (package wavin.aqora.v2, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import {proto3} from "@bufbuild/protobuf";
import {PeripheralAttributes} from "./system_pb.js";
import {TranslatableError} from "./system_mutation_pb.js";

/**
 * @generated from message wavin.aqora.v2.UpdatePeripheralRequest
 */
export const UpdatePeripheralRequest = proto3.makeMessageType(
  "wavin.aqora.v2.UpdatePeripheralRequest",
  () => [
      {no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */},
      {no: 2, name: "attributes", kind: "message", T: PeripheralAttributes},
  ],
);

/**
 * @generated from message wavin.aqora.v2.PeripheralResponse
 */
export const PeripheralResponse = proto3.makeMessageType(
  "wavin.aqora.v2.PeripheralResponse",
  () => [
      {no: 1, name: "success", kind: "message", T: PeripheralResponse_Success, oneof: "outcome"},
      {no: 2, name: "failure", kind: "message", T: PeripheralResponse_Failure, oneof: "outcome"},
  ],
);

/**
 * @generated from enum wavin.aqora.v2.PeripheralResponse.Field
 */
export const PeripheralResponse_Field = proto3.makeEnum(
  "wavin.aqora.v2.PeripheralResponse.Field",
  [
    {no: 0, name: "FIELD_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "FIELD_NAME", localName: "NAME"},
    {no: 10, name: "FIELD_ATTRIBUTES_VALVE_ACTUATOR_SIZE", localName: "ATTRIBUTES_VALVE_ACTUATOR_SIZE"},
    {no: 20, name: "FIELD_ATTRIBUTES_WATER_HEIGHT_SENSOR_OFFSET", localName: "ATTRIBUTES_WATER_HEIGHT_SENSOR_OFFSET"},
    {no: 21, name: "FIELD_ATTRIBUTES_WATER_HEIGHT_SENSOR_RANGE", localName: "ATTRIBUTES_WATER_HEIGHT_SENSOR_RANGE"},
      {
          no: 22,
          name: "FIELD_ATTRIBUTES_WATER_HEIGHT_SENSOR_POLDER_LEVEL",
          localName: "ATTRIBUTES_WATER_HEIGHT_SENSOR_POLDER_LEVEL"
      },
    {no: 30, name: "FIELD_ATTRIBUTES_TAP_ACTUATOR_FLOW", localName: "ATTRIBUTES_TAP_ACTUATOR_FLOW"},
    {no: 40, name: "FIELD_ATTRIBUTES_RAIN_SENSOR_BUCKET", localName: "ATTRIBUTES_RAIN_SENSOR_BUCKET"},
    {no: 50, name: "FIELD_ATTRIBUTES_TEMPERATURE_SENSOR_ADDRESS", localName: "ATTRIBUTES_TEMPERATURE_SENSOR_ADDRESS"},
    {no: 60, name: "FIELD_ATTRIBUTES_PUMP_MAX_FLOW_RATE", localName: "ATTRIBUTES_PUMP_MAX_FLOW_RATE"},
    {no: 61, name: "FIELD_ATTRIBUTES_PUMP_MIN_FLOW_RATE", localName: "ATTRIBUTES_PUMP_MIN_FLOW_RATE"},
    {no: 62, name: "FIELD_ATTRIBUTES_PUMP_CONTROL_TYPE", localName: "ATTRIBUTES_PUMP_CONTROL_TYPE"},
  ],
);

/**
 * @generated from message wavin.aqora.v2.PeripheralResponse.Success
 */
export const PeripheralResponse_Success = proto3.makeMessageType(
  "wavin.aqora.v2.PeripheralResponse.Success",
  [],
  {localName: "PeripheralResponse_Success"},
);

/**
 * @generated from message wavin.aqora.v2.PeripheralResponse.FieldError
 */
export const PeripheralResponse_FieldError = proto3.makeMessageType(
  "wavin.aqora.v2.PeripheralResponse.FieldError",
  () => [
      {no: 1, name: "field", kind: "enum", T: proto3.getEnumType(PeripheralResponse_Field)},
      {no: 2, name: "error", kind: "message", T: TranslatableError},
  ],
  {localName: "PeripheralResponse_FieldError"},
);

/**
 * @generated from message wavin.aqora.v2.PeripheralResponse.Failure
 */
export const PeripheralResponse_Failure = proto3.makeMessageType(
  "wavin.aqora.v2.PeripheralResponse.Failure",
  () => [
      {no: 1, name: "errors", kind: "message", T: TranslatableError, repeated: true},
      {no: 2, name: "field_errors", kind: "message", T: PeripheralResponse_FieldError, repeated: true},
  ],
  {localName: "PeripheralResponse_Failure"},
);

